export const ADMIN_ROUTES = [
  { label: 'Overview', path: '/overview', icon: '◫', available: true },
  { label: 'Sales', path: '/sales', icon: '↗', available: true },
  { label: 'Inventory', path: '/inventory', icon: '◇', available: true },
  { label: 'Residents & Tabs', path: '/residents', icon: '◎', available: true },
  { label: 'Staff', path: '/staff', icon: '♙', available: true },
  { label: 'Devices', path: '/devices', icon: '▣', available: true },
  { label: 'Reports', path: '/reports', icon: '▤', available: false },
  { label: 'Audit', path: '/audit', icon: '⌁', available: false },
  { label: 'Settings', path: '/settings', icon: '⚙', available: false },
] as const;
